import { Component, inject, signal } from '@angular/core';
import { NzButtonComponent } from 'ng-zorro-antd/button';
import { NzColDirective, NzRowDirective } from 'ng-zorro-antd/grid';
import { NzFormControlComponent, NzFormItemComponent, NzFormLabelComponent } from 'ng-zorro-antd/form';
import { NzIconDirective } from 'ng-zorro-antd/icon';
import { NzTreeSelectComponent } from 'ng-zorro-antd/tree-select';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NzModalModule, NzModalRef } from 'ng-zorro-antd/modal';
import { ClassificationCodeService } from '@beautyapp/core';

@Component({
  selector: 'beautyapp-ehr-add-ncsp',
  imports: [
    NzButtonComponent,
    NzColDirective,
    NzFormControlComponent,
    NzFormItemComponent,
    NzFormLabelComponent,
    NzIconDirective,
    NzRowDirective,
    NzTreeSelectComponent,
    ReactiveFormsModule,
    NzModalModule,
    FormsModule
  ],
  templateUrl: './ehr-add-ncsp.component.html',
  styleUrl: './ehr-add-ncsp.component.scss'
})
export class EhrAddNcspComponent {
  classificationCodeService = inject(ClassificationCodeService)
  modalRef = inject(NzModalRef)

  selectedNCSPIds = signal<number[]>([]);
  selectedNCSPs = signal<any[]>([]);


  onNCSPChange(event: any): void {
    console.log('onNCSPChange', event);

    // Get the selected nodes from the tree
    const selectedNodes = this.findSelectedNodes(this.classificationCodeService.classificationNCSPCodes(), event);
    this.selectedNCSPs.set(selectedNodes);
  }

  /**
   * Find nodes in the tree by their IDs
   * @param nodes The tree nodes to search in
   * @param ids The IDs to find
   * @returns The found nodes
   */
  private findSelectedNodes(nodes: any[], ids: number[]): any[] {
    if (!nodes || !ids || ids.length === 0) {
      return [];
    }

    const result: any[] = [];

    // Helper function to recursively search the tree
    const searchNodes = (nodeList: any[]) => {
      for (const node of nodeList) {
        if (ids.includes(node.key)) {
          result.push({
            id: node.key,
            code: node.code,
            nameGeo: node.name,
            nameEng: node.name,
            type: node.type,
          });
        }

        if (node.children && node.children.length > 0) {
          searchNodes(node.children);
        }
      }
    };

    searchNodes(nodes);
    return result;
  }

  submit(): void {
    console.log('submit', this.selectedNCSPIds());
    console.log('submit', this.selectedNCSPs());

    // Return both the IDs and the full objects to the caller
    this.modalRef.close({
      ids: this.selectedNCSPIds(),
      items: this.selectedNCSPs()
    });
  }
}
